import React, { useState, useEffect } from 'react';
import './FollowingCat.css';

export const FollowingCat = ({ onDismiss }) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [catPos, setCatPos] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const [lookDirection, setLookDirection] = useState('right');

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCatPos((prev) => {
        const dx = mousePos.x - prev.x;
        const dy = mousePos.y - prev.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Determine look direction
        if (Math.abs(dx) > Math.abs(dy)) {
          setLookDirection(dx > 0 ? 'right' : 'left');
        } else {
          setLookDirection(dy > 0 ? 'down' : 'up');
        }

        // Move cat towards mouse at a steady pace
        if (distance > 50) {
          const speed = 3;
          const moveX = (dx / distance) * speed;
          const moveY = (dy / distance) * speed;
          return {
            x: prev.x + moveX,
            y: prev.y + moveY,
          };
        }

        return prev;
      });
    }, 30);

    return () => clearInterval(interval);
  }, [mousePos]);

  const getCatArt = () => {
    const cats = {
      right: `
        ^__^
        (oo)\\_______
        (__)\\       )\\/\\
            ||----w |
            ||     ||`,
      left: `
        ^__^
    _______/(oo)
   /\\/       /(__)
   w----||    ||
    ||     ||`,
      up: `
          /\\_/\\
         ( o.o )
          > ^ <
         /|   |\\
        (_|   |_)`,
      down: `
        (_|   |_)
         \\|   |/
          > ^ <
         ( o.o )
          \\_O_/`,
    };
    return cats[lookDirection] || cats.right;
  };

  return (
    <div className="following-cat-container" onClick={onDismiss}>
      <div
        className="following-cat"
        style={{
          left: `${catPos.x}px`,
          top: `${catPos.y}px`,
        }}
      >
        <pre className="cat-art">{getCatArt()}</pre>
        <div className="dismiss-hint">Click to dismiss</div>
      </div>
    </div>
  );
};
